import * as React from 'react';
import ChatMessage from '../ChatMessage';
import {EventFormatType} from '../../../models/chatChannelModel/message/format';
import {styled} from '../../../utils';

interface ChatEventMessageProps {
  message: ChatMessage<EventFormatType>;
}

const Root = styled('span')({
  fontStyle: 'italic',
  fontSize: 12,
  textAlign: 'center',
  marginBottom: 8
});

export default class ChatEventMessage extends React.Component<ChatEventMessageProps, {}> {
  public render() {
    return <Root>{this.props.message.format.attachment.payload.text}</Root>;
  }
}



// WEBPACK FOOTER //
// ./src/components/ChatUI/ChatEventMessage/ChatEventMessage.tsx